var _style, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.61,
    height: 185.61,
    viewBox: "0 0 185.61 185.61"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#012846}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8,
    cy: 92.8,
    r: 92.8,
    fill: "#ffca05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.24,
    cy: 84.83,
    r: 8.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.36,
    cy: 84.83,
    r: 8.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.07 132.97H73.53a3.63 3.63 0 110-7.26h38.54a3.63 3.63 0 110 7.26z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODUuNjEiIGhlaWdodD0iMTg1LjYxIiB2aWV3Qm94PSIwIDAgMTg1LjYxIDE4NS42MSI+PHN0eWxlPi5zdDF7ZmlsbDojMDEyODQ2fTwvc3R5bGU+PGNpcmNsZSBjeD0iOTIuOCIgY3k9IjkyLjgiIHI9IjkyLjgiIGZpbGw9IiNmZmNhMDUiLz48Y2lyY2xlIGNsYXNzPSJzdDEiIGN4PSI1NS4yNCIgY3k9Ijg0LjgzIiByPSI4Ljc5Ii8+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iMTMwLjM2IiBjeT0iODQuODMiIHI9IjguNzkiLz48cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTEyLjA3IDEzMi45N0g3My41M2EzLjYzIDMuNjMgMCAxMTAtNy4yNmgzOC41NGEzLjYzIDMuNjMgMCAxMTAgNy4yNnoiLz48L3N2Zz4=";
export { SvgNote8 as ReactComponent };